export default __webpack_public_path__ + "static/media/comp-verified.687238e3.png";